// extracted by mini-css-extract-plugin
export default {"business_confirm_email":"BusinessConfirmationEmail_business_confirm_email__Yr94o","email":"BusinessConfirmationEmail_email__ABaxC"};